import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

const getDeviceType = (): string => {
  const ua = navigator.userAgent;
  if (/tablet|ipad|playbook|silk/i.test(ua)) return "tablet";
  if (/mobile|iphone|ipod|android|blackberry|opera mini|iemobile/i.test(ua)) return "mobile";
  return "desktop";
};

const getBrowser = (): string => {
  const ua = navigator.userAgent;
  if (ua.includes("Firefox")) return "Firefox";
  if (ua.includes("SamsungBrowser")) return "Samsung Browser";
  if (ua.includes("Opera") || ua.includes("OPR")) return "Opera";
  if (ua.includes("Edge") || ua.includes("Edg")) return "Edge";
  if (ua.includes("Chrome")) return "Chrome";
  if (ua.includes("Safari")) return "Safari";
  return "Unknown";
};

const getOS = (): string => {
  const ua = navigator.userAgent;
  if (ua.includes("Windows")) return "Windows";
  if (ua.includes("Mac OS")) return "macOS";
  if (ua.includes("Linux")) return "Linux";
  if (ua.includes("Android")) return "Android";
  if (/iPhone|iPad|iPod/.test(ua)) return "iOS";
  return "Unknown";
};

const VisitorTracker = () => {
  useEffect(() => {
    if (window.location.pathname !== "/") return;
    if (sessionStorage.getItem("visitor_tracked")) return;
    // Respect cookie/analytics consent (DPDP Act / GDPR). Only track when accepted.
    if (localStorage.getItem("cookie_consent") !== "accepted") return;

    const track = async () => {
      try {
        sessionStorage.setItem("visitor_tracked", "1");

        await supabase.functions.invoke("track-visitor", {
          body: {
            device_type: getDeviceType(),
            browser: getBrowser(),
            os: getOS(),
            screen_resolution: `${screen.width}x${screen.height}`,
            referrer: document.referrer || null,
            page_url: window.location.pathname,
            user_agent: navigator.userAgent,
          },
        });
      } catch {
        // Silent fail — no user-facing errors
      }
    };

    track();
  }, []);

  return null;
};

export default VisitorTracker;
